import { Component, OnInit, Input, OnChanges, Output, EventEmitter } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { GlobalServicesService } from 'src/app/services/global-services.service';
import { EmailServicesService } from 'src/app/services/email-services.service';
import { MessageService } from 'primeng/api';
import { FileUploadService } from 'src/app/services/file-upload.service';
import { nanoid } from 'nanoid'
import { EventServicesService } from 'src/app/services/event-services.service';
import { JobServicesService } from 'src/app/services/job-services.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute} from '@angular/router';
import { environment } from 'src/environments/environment';
import { SharedServicesService } from 'src/app/services/shared-services.service';
import { DEADLINE_OPTIONS } from 'src/app/constants/deadline-options';

declare let tinymce: any;

interface JobRole {
  id: number;
  name: string;
  cities: string[];
}
interface errorHandler {
  error_file?: string;
  detail?: string;
}
@Component({
    selector: 'app-send-email',
    templateUrl: './send-email.component.html',
    styleUrls: ['./send-email.component.css'],
    providers: [MessageService],
    standalone: false
})
export class SendEmailComponent implements OnInit, OnChanges {

  tinymce_api_key = environment.HOST.TINYMCE_API_KEY;

  @Input() selectedUsersList: any = [];
  @Input() location: string = 'stage';
  @Input() sendMailHeader: string = '';
  @Input() assignCohortData: boolean = false;
  @Input() sendDocumentation: boolean = false;
  @Output() mailSent = new EventEmitter<boolean>();
  @Input() stage: any;
  
  emails: any = [];
  schoolDetails: any = localStorage.getItem('company-details');
  fromAddress = JSON.parse(this.schoolDetails).company_metadata.from_email;
  eventId: string = '';
  cohortNameTerm: string = '';
  companyId: any;
  cohortStatuses: any = {};
  selectedCohortStatus: any = {};
  jobRolesWithCities: JobRole[] = [];
  jobRolesList: Array<{ label: string; value: number }> = [];
  documentationLocationsList: Array<{ label: string; value: string }> = [];
  offerLocationsList: Array<{ label: string; value: string }> = [];
  loggedUser: any = {};

  loader: boolean = false;
  clicked: boolean = false;
  uploadingFile: boolean = false;
  errorPlaceholder: string[] = [];
  placeholders: Array<{ value: string; tag: string }> = [];
  showPlaceholder: boolean = false;
  templatesList: any = [];
  eventUsers: any = [];
  selectedLocation: string[] = []; 
  // attachmentFile: File[] = [];
  attachmentFile: any;
  deadlineList: any = [];

  sendEmailSlider: boolean = false;
  editingTemplate: boolean = false;
  selectedTemplate: any = null;
  sendEmailForm: FormGroup = new FormGroup({
    fromAddress: new FormControl(this.fromAddress),
    toAddress: new FormControl('', [Validators.required]),
    subjectTitle: new FormControl('', [Validators.required]),
    attachment: new FormControl(''),
    template: new FormControl(''),
  })

  sendOfferForm: FormGroup = new FormGroup({
    // cohort_id: new FormControl(null, [Validators.required]),
    // cohortLocation: new FormControl(null),
    cohortJobRole: new FormControl(null, [Validators.required]),
    cohortJobLocation: new FormControl(null, [Validators.required]),
    // offerPOC: new FormControl(null),
    offerDeadline: new FormControl(null, [Validators.required]),

    fromAddress: new FormControl(this.fromAddress),
    toAddress: new FormControl('', [Validators.required]),
    subjectTitle: new FormControl('', [Validators.required]),
    template: new FormControl(null, [Validators.required]),
  })
  roles: any;
  candidateId: any;

  constructor(
    public globalService: GlobalServicesService,
    public emailService: EmailServicesService,
    public messageService: MessageService,
    private fileUploadService: FileUploadService,
    private eventServices: EventServicesService,
    private jobServices: JobServicesService,
    private activatedRoute: ActivatedRoute,
    private sharedService: SharedServicesService
  ) {
    this.deadlineList = DEADLINE_OPTIONS;
  }

  ngOnInit() {
    this.companyId = localStorage.getItem('companyUUID') ?? '';
    this.activatedRoute.params.subscribe(params => {
      this.eventId = params['eventId'] || '';
      if (this.eventId && this.location !== 'talentPool') {
        this.getEventStageFormData();
      }
    });
    this.loggedUser = localStorage.getItem('userDetails') ? JSON.parse(localStorage.getItem('userDetails') || '') : ''
    
    if(this.sendDocumentation){
      this.sendEmailForm.addControl('documentCohortLocation', new FormControl(null));
      this.sendEmailForm.addControl('documentCohortJobRole', new FormControl(null, [Validators.required]));
      this.sendEmailForm.addControl('documentDeadline', new FormControl(null, [Validators.required]));
      this.sendEmailForm.get('template')!.setValidators([Validators.required]);
      this.sendEmailForm.addControl('documentPOC', new FormControl(null, [Validators.required]));
    }
    if (this.location === 'talentPool') {
      this.getEmailTemplates();
    }
    
    // Load TinyMCE immediately if no template is selected
    setTimeout(() => {
      if (!this.selectedTemplate) {
        this.loadTinyMce();
      }
    }, 500);
  }
  getTemplateType = (): string => {
    if (this.sendDocumentation) {
      return 'Documentation';
    } else if (this.assignCohortData) {
      return 'Offer';
    }
    return 'Others';
  }

  getEventStageFormData = () => {
    const templateType = this.getTemplateType();
    this.eventServices.getEventStageActionFormDataFastApi(this.eventId, templateType).subscribe({
      next: (response) => {
        if (response.status === 200) {
          let templateList = response.body.email_templates ? response.body.email_templates : [];
          this.templatesList = templateList.map((item: any) => ({
            id: item.id,
            templateTitle: item.name,
          }));
          if (response?.body?.job_roles) {
            const roles: JobRole[] = response.body.job_roles || [];
            this.jobRolesWithCities = roles;
            this.jobRolesList = roles.map(role => ({
              label: role.name,
              value: role.id
            }));
            this.documentationLocationsList = [];
            this.offerLocationsList = [];
          }

          this.roles = response.body.roles ? response.body.roles : [];
        }
      },
      error: (_err) => {
      }
    });
  }

  onDocumentationJobRoleChange = (roleId: number | null) => {
    this.documentationLocationsList = [];
    this.selectedLocation = [];
    this.sendEmailForm.patchValue({ documentCohortLocation: null });
    if (roleId == null) return;
    const role = this.jobRolesWithCities.find(r => r.id === roleId);
    if (role?.cities?.length) {
      this.documentationLocationsList = role.cities.map(city => ({ label: city, value: city }));
    }
  };

  onOfferJobRoleChange = (roleId: number | null) => {
    this.offerLocationsList = [];
    this.selectedLocation = [];
    this.sendOfferForm.patchValue({ cohortJobLocation: null });
    if (roleId == null) return;
    const role = this.jobRolesWithCities.find(r => r.id === roleId);
    if (role?.cities?.length) {
      this.offerLocationsList = role.cities.map(city => ({ label: city, value: city }));
    }
  };

  getOwnerDetails = (roleId: any) => {
    this.jobServices.getUserByRoleIdFastApi(roleId).subscribe({
      next: (response: any) => {
        const ownerDetails =  Object.keys(response.body.users).length !== 0 ? response.body.users : [];
        this.eventUsers = ownerDetails.map((owner:any) => ({
          label: `${owner.first_name} ${owner.last_name}`,
          value: owner.id
        }));;
      },
    });
  }

  getEmailTemplates = () => {
    this.emailService.getTemplatesFastApi('', 'Others').subscribe({
      next: (response) => {
        if (response.status === 200) {
          let templateList = response.body.email_templates ? response.body.email_templates : [];
          this.templatesList = templateList.map((item: any) => ({
            id: item.id,
            isEditable: item.is_editable,
            templateTitle: item.name,
          }));
        }
      },
      error: (_err) => {
      }
    });
  };

  ngOnChanges() {
    if (this.stage?.email_template && (this.sendDocumentation || this.assignCohortData)) {
      this.getSpecificTemplateData(this.stage.email_template).then(() => {
        if (this.sendDocumentation || this.assignCohortData) {
          this.validateTemplate();
        }
        const categoryId = this.selectedTemplate?.email_category_id;
        if (categoryId) {
          this.emailTemplateFormData(String(categoryId));
        }
      });
      const template = { id: this.stage.email_template.id, templateTitle: this.stage.email_template.name };
      this.sendEmailForm.controls['template'].setValue(template);
      this.sendOfferForm.controls['template'].setValue(template);
    }
    this.emails = this.selectedUsersList.map((user: any) => user.email)
    this.candidateId = this.selectedUsersList.map((user: any) => user.candidate_uuid)
    this.sendEmailForm.controls['toAddress'].setValue(this.emails);
    this.sendOfferForm.controls['toAddress'].setValue(this.emails);
  }

  isSendButtonDisabled(): boolean {
    if (this.loader) return true;
    if (this.sendDocumentation || this.assignCohortData) {
      return !this.selectedTemplate || this.errorPlaceholder.length > 0;
    }
    return false;
  }

  validateTemplate(): void {
    this.errorPlaceholder = [];
    const templateBody: string = (this.selectedTemplate?.body ?? '').replace(/\/\$\{/g, '${');
    const placeholdersByContext: Record<string, Record<string, string>> = {
      Documentation: {
        User: '${full_name}',
        document_link: '${document_link}'
      },
      Offer: {
        User: '${full_name}',
        offer_link: '${offer_link}'
      }
    };
    const context = this.sendDocumentation ? 'Documentation' : (this.assignCohortData ? 'Offer' : null);
    if (context && placeholdersByContext[context]) {
      for (const key of Object.keys(placeholdersByContext[context])) {
        if (!templateBody.includes(placeholdersByContext[context][key])) {
          this.errorPlaceholder.push(key);
        }
      }
    }
  }

  emailTemplateFormData = (categoryId: string) => {
    if (!categoryId) return;
    this.emailService.getEmailTemplateFormDataFastApi(categoryId).subscribe({
      next: (response) => {
        if (response.status === 200) {
          const data = response.body;
          const placeholderList = Array.isArray(data) && data.length > 0 ? data[0].placeholders : [];
          this.placeholders = placeholderList.map((placeholder: string) => ({
            value: ` \${${placeholder}} `,
            tag: placeholder,
          }));
        }
      },
      error: (_err) => { }
    });
  }

  insertPlaceholder = (value: string) => {
    try {
      if (typeof tinymce !== 'undefined' && tinymce.activeEditor) {
        tinymce.activeEditor.focus();
        tinymce.activeEditor.insertContent(value);
      }
    } catch (_e) { }
  }

  async emailWrite(event: any) {
    this.selectedTemplate = event.value;
    if (event.value) {
      await this.getSpecificTemplateData(event.value);
      const categoryId = this.selectedTemplate?.email_category_id;
      if (categoryId) {
        this.emailTemplateFormData(String(categoryId));
      } else {
        this.placeholders = [];
      }
      if (this.sendDocumentation || this.assignCohortData) {
        this.validateTemplate();
      }
      // Hide TinyMCE when template is selected
      this.editingTemplate = false;
      if (typeof tinymce !== 'undefined') {
        tinymce.remove();
      }
    } else {
      this.errorPlaceholder = [];
      this.placeholders = [];
      // Show TinyMCE when no template is selected
      this.selectedTemplate = null;
      this.editingTemplate = false;
      setTimeout(() => {
        this.loadTinyMce();
      }, 100);
    }
  }

  editEmailTemplate(editing: boolean) {
    this.editingTemplate = editing;
    if (editing && this.selectedTemplate) {
      setTimeout(() => {
        this.loadTinyMce(this.selectedTemplate);
      }, 100);
    }
  }

  closeSendEmail() {
    this.mailSent.emit(false);
  }
  async getSpecificTemplateData(template: any): Promise<void> {
    if (template.id) {
      return new Promise((resolve, reject) => {
        this.emailService.getSpecificTemplateFastApi(template.id).subscribe({
          next: (response) => {
            if (response.status === 200) {
              this.selectedTemplate = {
                ...this.selectedTemplate,
                body: response.body.body,
                email_category_id: response.body.email_category_id
              };
              this.sendEmailForm.controls['subjectTitle'].setValue(response.body.subject);
              this.sendOfferForm.controls['subjectTitle'].setValue(response.body.subject);
              if (this.editingTemplate) {
                this.loadTinyMce(response.body);
              }
              resolve();
            }
          },
          error: (err) => {
            reject(new Error('Error fetching specific template: ' + err));
          }
        });
      });
    }
  }
  submit = async () => {
    if (this.loader) {
      return;
    }
    
    this.clicked = true;
    this.sendEmailForm.get('subjectTitle')?.markAsTouched();
    this.sendOfferForm.get('subjectTitle')?.markAsTouched();
    let hasSecurityViolation = false;
    let formToCheck = this.sendDocumentation || !this.assignCohortData ? this.sendEmailForm : this.sendOfferForm;
    
    if (this.sharedService.hasSecurityViolations(formToCheck, ['subjectTitle'])) {
      hasSecurityViolation = true;
    }

    if (hasSecurityViolation) {
      this.messageService.add({ 
        severity: 'error', 
        summary: 'Invalid Input', 
        detail: 'Invalid input format in some fields.' 
      });
      return;
    }

    if (this.sendDocumentation && this.sendEmailForm.valid) {
      if (this.selectedTemplate) {
        this.validateTemplate();
        if (this.errorPlaceholder.length > 0) {
          this.messageService.add({
            severity: 'error',
            summary: 'Invalid Template',
            detail: 'Please select a template that includes: ' + this.errorPlaceholder.join(', ')
          });
          return;
        }
      }
      this.loader = true;
      let body = '';
      
      // Check if we're using a template or TinyMCE
      if (this.selectedTemplate && !this.editingTemplate) {
        // Using template preview - get content from selected template
        body = this.selectedTemplate?.body || '';
      } else {
        // Using TinyMCE - get content from editor
        if (typeof tinymce !== 'undefined' && tinymce.get(0)) {
          body = tinymce.get(0).getContent() || '';
        } else {
          body = '';
        }
      }
      
      body = body.replace(/\/\$\{/g, "${");

      let secureFormValue = this.sharedService.getSecurePayload(this.sendEmailForm.value);

      let payload: any = {
        "candidate_uuids": this.candidateId,
        "subject": secureFormValue.subjectTitle,
        "body": body,
        "job_role_id": this.sendEmailForm.controls['documentCohortJobRole'].value,
        "locations": this.sendEmailForm.controls['documentCohortLocation'].value,
        "documentation_poc_id": this.sendEmailForm.controls['documentPOC'].value,
        "submission_deadline": this.sendEmailForm.controls['documentDeadline'].value
      };
      if (this.sendEmailForm.controls['attachment'].value) {
        payload['attachment'] = this.sendEmailForm.controls['attachment'].value;
      }

      this.emailService.sendDocumentationEmailFastApi(payload, this.eventId, this.stage.uuid).subscribe({
        next: (response) => {
          this.globalService.commonGrowl.next({
            severity: 'success',
            summary: 'Success',
            detail: response.body.detail,
          });
          this.sendEmailForm.reset();
          this.sendOfferForm.reset();
          if (typeof tinymce !== 'undefined' && tinymce.activeEditor) {
            tinymce.activeEditor.setContent('');
          }
          this.mailSent.emit(true);
          this.clicked = false;
          this.loader = false;
        },
        error: (error: HttpErrorResponse) => {
          const errorResponse = error.error as errorHandler;
          this.clicked = false;
          this.loader = false;
          this.sendEmailForm.controls['attachment'].setValue('');

          if (this.attachmentFile && this.attachmentFile.length > 0) {
            this.attachmentFile.splice(0, 1);
          }

          if (errorResponse.detail === "File not found.") {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'File not found. Please try uploading again.'
            });
            return;
          }

          let errorMessage = 'Something went wrong.';
          if (Array.isArray(errorResponse.detail)) {
            errorMessage = errorResponse.detail[0]?.msg || errorResponse.detail[0]?.ctx?.error || 'Something went wrong.';
          } else if (typeof errorResponse.detail === 'string') {
            errorMessage = errorResponse.detail;
          }

          this.messageService.add({
            severity: 'warn',
            summary: 'Warning',
            detail: errorMessage
          });
        }
      });
    }
    else if (this.assignCohortData) {
      if (!this.sendOfferForm.valid) {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Please fill all mandatory fields before sending offer email.'
        });
        return;
      }
      if (this.selectedTemplate) {
        this.validateTemplate();
        if (this.errorPlaceholder.length > 0) {
          this.messageService.add({
            severity: 'error',
            summary: 'Invalid Template',
            detail: 'Please select a template that includes: ' + this.errorPlaceholder.join(', ')
          });
          return;
        }
      }
      this.loader = true;
      let body = '';
      
      // Check if we're using a template or TinyMCE
      if (this.selectedTemplate && !this.editingTemplate) {
        // Using template preview - get content from selected template
        body = this.selectedTemplate?.body || '';
      } else {
        // Using TinyMCE - get content from editor
        if (typeof tinymce !== 'undefined' && tinymce.get(0)) {
          body = tinymce.get(0).getContent() || '';
        } else {
          body = '';
        }
      }
      
      if (!body || body.trim() === '' || body === '<p><br></p>' || body === '<p></p>') {
        this.loader = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Email body is mandatory. Please enter the email content.'
        });
        return;
      }
      
      body = body.replace(/\/\$\{/g, "${");
      let secureFormValue = this.sharedService.getSecurePayload(this.sendOfferForm.value);

      let payload: any = {
        "candidate_uuids": this.candidateId,
        "subject": secureFormValue.subjectTitle,
        "body": body,
        "job_role_id": this.sendOfferForm.controls['cohortJobRole'].value,
        "locations": this.sendOfferForm.controls['cohortJobLocation'].value,
        "submission_deadline": this.sendOfferForm.controls['offerDeadline'].value
      };
      
      if (this.sendEmailForm.controls['attachment'].value) {
        payload['attachment'] = this.sendEmailForm.controls['attachment'].value;
      }

      this.emailService.sendOfferEmailFastApi(payload, this.eventId, this.stage.uuid).subscribe({
        next: (response) => {
          this.globalService.commonGrowl.next({
            severity: 'success',
            summary: 'Success',
            detail: response.body.detail,
          });
          this.sendOfferForm.reset();
          if (typeof tinymce !== 'undefined' && tinymce.activeEditor) {
            tinymce.activeEditor.setContent('');
          }
          this.mailSent.emit(true);
          this.clicked = false;
          this.loader = false;
        },
        error: (error: HttpErrorResponse) => {
          const errorResponse = error.error as errorHandler;
          this.clicked = false;
          this.loader = false;
          
          if (this.sendEmailForm.controls['attachment']) {
            this.sendEmailForm.controls['attachment'].setValue('');
          }

          if (this.attachmentFile && this.attachmentFile.length > 0) {
            this.attachmentFile.splice(0, 1);
          }

          if (errorResponse.detail === "File not found.") {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'File not found. Please try uploading again.'
            });
            return;
          }

          let errorMessage = 'Something went wrong.';
          if (Array.isArray(errorResponse.detail)) {
            errorMessage = errorResponse.detail[0]?.msg || errorResponse.detail[0]?.ctx?.error || 'Something went wrong.';
          } else if (typeof errorResponse.detail === 'string') {
            errorMessage = errorResponse.detail;
          }

          this.messageService.add({
            severity: 'warn',
            summary: 'Warning',
            detail: errorMessage
          });
        }
      });

    }
    else {
      if (this.sendEmailForm.valid) {
        this.sendMail();
      }
    }
  }

  
  async sendMail() {
    this.loader = true;
    let body = '';
    
    // Check if we're using a template or TinyMCE
    if (this.selectedTemplate && !this.editingTemplate) {
      // Using template preview - get content from selected template
      body = this.selectedTemplate?.body || '';
    } else {
      // Using TinyMCE - get content from editor
      if (typeof tinymce !== 'undefined' && tinymce.get(0)) {
        body = tinymce.get(0).getContent() || '';
      } else {
        body = '';
      }
    }
    
    if (!body || body.trim() === '') {
      this.loader = false;
      this.globalService.commonGrowl.next({
        severity: 'error',
        summary: 'Error',
        detail: 'Email body is mandatory. Please enter the email content.',
      });
      return;
    }
    body = body.replace(/\/\$\{/g, "${");
    let secureFormValue = this.sharedService.getSecurePayload(this.sendEmailForm.value);
    
    let payload: any = {
      candidate_uuids: this.selectedUsersList.map((each: any) => each.candidate_uuid || each.uuid),
      subject: secureFormValue.subjectTitle,
      body: body
    }
    
    if (this.sendEmailForm.value.attachment) {
      payload['attachment'] = this.sendEmailForm.value.attachment;
    }
    if(this.stage){
      this.emailService.stageActionSendEmailFastApi(payload, this.stage.id, this.eventId).subscribe({
        next: (response) => {
          this.globalService.commonGrowl.next({
            severity: 'success',
            summary: 'Success',
            detail: response.body.detail,
          });
          this.sendEmailForm.reset();
          this.sendOfferForm.reset();
          // Clear TinyMCE content if editor is available
          if (typeof tinymce !== 'undefined' && tinymce.activeEditor) {
            tinymce.activeEditor.setContent('');
          }
          // Reset template selection
          this.selectedTemplate = null;
          this.editingTemplate = false;
          // Reset attachment
          this.attachmentFile = null;
          this.mailSent.emit(true);
          this.clicked = false;
          this.loader = false;
        },
        error: (_err) => {
          this.loader = false;
        }
      });
    } else {
      this.emailService.sendEmailFastApi(payload).subscribe({
        next: (response) => {
          this.globalService.commonGrowl.next({
            severity: 'success',
            summary: 'Success',
            detail: response.body.detail,
          });
          this.sendEmailForm.reset();
          this.sendOfferForm.reset();
          // Clear TinyMCE content if editor is available
          if (typeof tinymce !== 'undefined' && tinymce.activeEditor) {
            tinymce.activeEditor.setContent('');
          }
          // Reset template selection
          this.selectedTemplate = null;
          this.editingTemplate = false;
          // Reset attachment
          this.attachmentFile = null;
          this.mailSent.emit(true);
          this.clicked = false;
          this.loader = false;
        },
        error: (_err) => {
          this.loader = false;
        }
      });
    }
  }

  handleUpload(event: any, type: string, acl?: boolean) {
    const file = event.addedFiles[0];
    const fileName = this.generateFileName(file);
    const renamedFile = new File([file], fileName, {
      type: file.type,
      lastModified: file.lastModified,
    });
    event.addedFiles[0] = renamedFile;
    const reader = new FileReader();
    reader.readAsDataURL(renamedFile);
    reader.onload = () => {
      this.fileUpload(renamedFile, fileName);
    };
  }

  private generateFileName(file: any): string {
    let fileName = file.name.split(".");
    let fileExtension = fileName.pop();
    const timestamp = new Date().getTime();
    return `${fileName.join().replace(/\s/g, "").replace(/[^\w\s]/gi, '')}_${timestamp}.${fileExtension}`;
  }

  uploadFileToGCS(signedUrl: string, file: any, filePath: string, fileName: string) {
    this.fileUploadService.uploadUsingSignedUrlGCS(signedUrl, file).subscribe({
      next: (response: any) => {
        if (response && response.status === "success") {
          this.sendEmailForm.controls['attachment'].setValue(fileName);
          this.uploadingFile = false;
        }
      },
      error: (error) => {
        if (this.attachmentFile && this.attachmentFile.length > 0) {
          this.attachmentFile.splice(0, 1);
        }
        this.sendEmailForm.controls['attachment'].setValue('');
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error uploading file to GCS' });
        this.uploadingFile = false;
      }
    });
  }

  fileUpload(file: any, fileName: string) {
    this.uploadingFile = true;
    const filePath = `temp/${this.companyId}/${fileName}`;
    const payload = {
      file_path: filePath,
      bucket_type:'private',
      origin:"send_email",
    };
    const isCandidate = false;
    this.fileUploadService.getSignedUrlGCS(payload, isCandidate).subscribe({
      next: (response: any) => {
        if (response && response.body.signed_url) {
          this.uploadFileToGCS(response.body.signed_url, file, filePath, fileName);
        }
      },
      error: (error) => {
        this.uploadingFile = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error getting signed URL' });
      }
    });
  }

  onSelectMedia(event: any, acl?: boolean) {
    this.attachmentFile = event.addedFiles;
    this.handleUpload(event, 'attachment', acl)
  }

  onRemoveMedia(event: any) {
    this.attachmentFile.splice(this.attachmentFile.indexOf(event), 1);
    this.sendEmailForm.controls['attachment'].setValue('');
  }

  async loadTinyMce(template?: any) {
    await this.globalService.loadScript(
      'script',
      `https://cdn.tiny.cloud/1/${this.tinymce_api_key}/tinymce/8.0.2/tinymce.min.js`,
      'text/javascript',
      'examlyck'
    );
    if (typeof tinymce === 'undefined') {
      return;
    }
    tinymce?.remove();
    await tinymce
      .init({
        selector: 'textarea',
        content_style:
          "@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600&display=swap'); body { font-family: Poppins; }",
        height: 400,
        menu: '',
        plugins: 'preview searchreplace autolink directionality code visualblocks visualchars fullscreen link media codesample table charmap pagebreak nonbreaking anchor insertdatetime advlist lists wordcount help quickbars emoticons save autoresize image',
        toolbar: 'undo redo | bold italic underline strikethrough | fontfamily fontsize blocks | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media link anchor codesample | ltr rtl',
        branding: false,
        toolbar_sticky: true,
        paste_data_images: true,
        image_caption: true,
        automatic_uploads: true,
        images_upload_handler: (blobInfo: any): Promise<string> => {
          return new Promise((resolve, reject) => {
            const blob = blobInfo.blob();
            if (!this.companyId) { reject({ message: 'Upload failed: missing company ID', remove: true }); return; }
            const originalName = blobInfo.filename() || `image_${Date.now()}.png`;
            const nameParts = originalName.split('.');
            const ext = nameParts.pop();
            const safeExt = ext ? `.${ext}` : '.png';
            const safeName = `${nameParts.join('').replace(/[^\w]/g, '')}_${Date.now()}${safeExt}`;
            const file = new File([blob], safeName, { type: blob.type });
            const filePath = `temp/${this.companyId}/${safeName}`;

            this.fileUploadService.getSignedUrlGCS({ file_path: filePath, bucket_type: 'public', origin: 'email_template' }).subscribe({
              next: (response: any) => {
                const signedUrl = response?.body?.signed_url;
                if (!signedUrl) { reject({ message: 'Failed to get upload URL', remove: true }); return; }
                this.fileUploadService.uploadUsingSignedUrlGCS(signedUrl, file).subscribe({
                  next: (event: any) => {
                    if (event?.status === 'success') {
                      resolve(signedUrl.split('?')[0]);
                    }
                  },
                  error: () => reject({ message: 'Image upload failed', remove: true })
                });
              },
              error: () => reject({ message: 'Failed to get upload URL', remove: true })
            });
          });
        },
        quickbars_selection_toolbar:
          'bold italic | quicklink h2 h3 blockquote quickimage quicktable',
        noneditable_noneditable_class: 'mceNonEditable',
        toolbar_mode: 'wrap',
        contextmenu: 'link image imagetools table',
        deprecation_warnings: false,
        relative_urls: false,
        convert_urls: false,
        min_height: 400,
        max_height: 400,
        autoresize_bottom_margin: 0,
        autoresize_overflow_padding: 0,
        setup: (editor: any) => {
          editor.on('init', () => {
            if (template?.body) {
              editor.setContent(template.body);
            }
          });
        }
      });
  }


  selectStatus(item: any, cohortOP: any) {
    cohortOP.hide();
    this.cohortNameTerm = item.cohort_name;
    this.selectedCohortStatus = item;
    this.selectedCohortStatus.cohort_date = new Date(this.selectedCohortStatus.cohort_date);
    this.selectedCohortStatus.cohort_spoc = this.eventUsers.filter((each: any) => each.id == this.selectedCohortStatus.cohort_spoc)[0];
  }

  selectCohort = (event: any) => {
    this.selectedCohortStatus = event.value;
  }

  dataURItoBlob(dataURI: any, type: any) {
    dataURI = dataURI.split('" ')[0];
    const binary = atob(dataURI.split(',')[1]);
    const array = [];
    for (let i = 0; i < binary.length; i++) {
      array.push(binary.charCodeAt(i));
    }
    return new Blob([new Uint8Array(array)], { type: type });
  }
}